import placeholder from '../assets/images/placeholder.jpeg';
import { BASE_URL } from "../configs/app-global";

export default function getImage(url) {
  if (!url) {
    return placeholder;
  }
  return BASE_URL + "/" + url;
}
